@if(title) {<H1>{{ title }} 
  @if(counter) {<span>({{ counter }})</span> } </H1> }
<app-http-loader [componentId]="componentId">
  @if(filteredAlpacas) {
  <ng-container> 
    @if(filteredAlpacas.length === 0) {
    <div>
      <p>{{noResultsMessage}}</p>
    </div>
    }
    @for(alpaca of filteredAlpacas; track alpaca) {
      <div>
        <app-alpaca-card [alpaca]="alpaca"></app-alpaca-card>
      </div>
    }
  </ng-container>
  }
</app-http-loader>